/* eslint-disable no-undef */
import axios from "axios";
import jwt_decode from "jwt-decode";
import Storage from "../storage";
import { removeStorageItems } from "../../components/PrivateRoutes/removeStorageItems";
import Alert from "../Alert";

export const clearStorage = () => {
  removeStorageItems()
  Alert(true, "danger", "Error message", "Session expired, please login");
  window.location.href = "/login"
};

export function checkRefreshToken(customAxiosInstance, userRefreshToken) {
  customAxiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (err) => {
      try {
        const originalReq = err.config;
        if (checkFunction(originalReq, err)) {
          return await trueFunction(originalReq, userRefreshToken);
        } else {
          routeToLogin(err);
          return err;
        }
      } catch (error) {
        return error;
      }
    }
  );
}

function routeToLogin(err) {
  if (
    (err.response &&
      err.response.data &&
      err.response.data.message &&
      err.response.data.message.toLowerCase() ===
      "refresh token has expired") ||
    (err.response &&
      err.response.data &&
      err.response.data.message &&
      err.response.data.message.toLowerCase() === "invalid refresh token")
  ) {
    clearStorage();
  }
}

function checkFunction(originalReq, err) {
  return (
    originalReq &&
    !originalReq._retry &&
    ((err.response.data.message &&
      err.response.data.message.toLowerCase() ===
      "failed to authenticate token") ||
      (err.response.data.message &&
        err.response.data.message.toLowerCase() === "jwt expired"))
  );
}

async function trueFunction(originalReq, userRefreshToken) {
  try {
    originalReq._retry = true;

    let response = await fetch(
      process.env.REACT_APP_API_KEY + "refresh-token",
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
        referrer: "no-referrer",
        body: JSON.stringify({
          refreshToken: userRefreshToken,
        }),
      }
    );

    let res = await setStorageFunction(response);

    originalReq.headers["Authorization"] = res?.data?.token;

    return axios(originalReq);
  } catch (error) {
    clearStorage();
  }
}
async function trueKongFunction(originalReq, userRefreshToken) {
  try {
    originalReq._retry = true;

    let response = await fetch(
      process.env.REACT_APP_KONG_GET_BEARER_API,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
        referrer: "no-referrer",
        body: JSON.stringify({
          refreshToken: userRefreshToken,
        }),
      }
    );

    let res = await setStorageFunction(response);

    originalReq.headers["Authorization"] = res && res.data && res.data.token;

    return axios(originalReq);
  } catch (error) {
    clearStorage();
  }
}

async function setStorageFunction(response) {
  let res = await response.json();
  if (res && res.code === 400) {
    throw res.message;
  } else {
    Storage.set("current-user", res && res.data);
    Storage.set("user-access-token", res && res.data && res.data.token);
    Storage.set("user-access-refresh-token", res && res.data && res.data.refresh_token);
    Storage.set("user-access-data", JSON.stringify(res.data.user));
    Storage.set("decoded-data", JSON.stringify(jwt_decode(res.data.token)));
    return res;
  }
}
